import { EntityType } from "@mapmycustomers/shared/enum";

import { GlobalSearchEntity, GlobalSearchGroup } from "@app/types/globalSearch/GlobalSearchItem";

export const isSearchGroup = (
  searchEntity: GlobalSearchEntity
): searchEntity is GlobalSearchGroup =>
  !!searchEntity.entity &&
  [EntityType.COMPANY_GROUP, EntityType.DEAL_GROUP, EntityType.PEOPLE_GROUP].includes(
    searchEntity.entity
  );
